<template>
	<sf-modal-layout class="qms-xl" ref="modal" :title="getMessage_('QWCC001097')" :show="show_" :closeModal="closeModal">
		<div class="sf-actions">
			<div className="sf-actions__left">
				<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
					{{ getMessage_('SWCC000007') }}
				</sf-button>
				<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
					{{ getMessage_('SWCC000327') }}
				</sf-button>
				<sf-button v-if="isButton_(scrId, 'CD')" line icon="trash" color="error" :onClick="deleteAction">
					{{ getMessage_('SWCC000328') }}
				</sf-button>
			</div>
		</div>
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<sf-data-table
						ref="CmpnPartTable"
						:paging="false"
						:columns="columns"
						:rows="rows"
						:addRowData="addRowData"
						:stripe="false"
						fit
						height="350px"
						selection
					>
						<!--컬럼에 아이콘 등록방법 시작 -->
						<template v-slot:customRows="slotProps">
							<template v-if="slotProps.column.property === 'partNo'">
								<!-- {{ test(slotProps) }} -->
								<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
									<el-input :value="slotProps.row[slotProps.column.property]" maxlength="10" />
									<span class="unit input-icon">
										<i class="icon-sf-search search-icon" @click="onCausePartPopup(slotProps)" :style="searchStye"></i>
									</span>
								</template>
								<template v-else>
									{{ slotProps.row.partNo }}
								</template>
							</template>

							<template v-if="slotProps.column.property === 'opCd'">
								<template v-if="slotProps.row.rowType && slotProps.row.rowType === 'add'">
									<el-input :value="slotProps.row[slotProps.column.property]" maxlength="10" />
									<i class="icon-sf-search search-icon" @click="onOpCdPopup(slotProps)" :style="searchStye"></i>
								</template>
								<template v-else>
									{{ slotProps.row.opCd }}
								</template>
							</template>
							<!--partCst 부품가격 -->
							<template v-if="slotProps.column.property === 'partCst'">
								<div class="position-relative h-100">
									<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)">
									</el-input>
								</div>
							</template>
							<!--qty 수량 -->
							<template v-if="slotProps.column.property === 'qty'">
								<div class="position-relative h-100">
									<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)">
									</el-input>
								</div>
							</template>
							<!--stdCst 기준금액-->
							<!-- <template v-if="slotProps.column.property === 'stdCst'">
								<div class="position-relative h-100">
									<el-input class="pr-2" :value="slotProps.row[slotProps.column.property]" @input="val => onChange(val, slotProps)">
									</el-input>
								</div>
							</template> -->

							<!--Lts -->
							<template v-if="slotProps.column.property === 'lts'">
								<div class="position-relative h-100">
									<el-input
										class="pr-2"
										:value="slotProps.row[slotProps.column.property]"
										maxlength="4"
										@input="val => onChange(val, slotProps)"
									>
									</el-input>
								</div>
							</template>
							<!-- amt 금액/자재비-->
							<template v-if="slotProps.column.property === 'amt'">
								{{ Math.round(slotProps.row.partCst * slotProps.row.qty * 100) / 100 }}
							</template>
							<!--공임비 wags -->
							<template v-if="slotProps.column.property === 'wags'">
								{{ Math.round(slotProps.row.lts * slotProps.row.stdCst * 100) / 100 }}
							</template>
						</template>
						<!--컬럼에 아이콘 등록방법 끝 -->
					</sf-data-table>
				</sf-card>
			</div>
		</div>
	</sf-modal-layout>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/CmpnMst/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			addRowData: {
				rowType: 'add',
				partNo: '',
				partNm: '',
				lts: '', //lts
				qty: '', //수량
				partCst: '', //as 부품가격
				stdCst: '', //기준금액
				amt: '', //자재비
				wags: '' //공임비
			},
			searchStye: {
				//그리드 버튼 스타일 지정
				top: '8px',
				right: '7px'
			},
			partNoInput: '', //품번팝업 호출시 매개체
			selGridRowIndex: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.cmpnPartList;
		},
		selectedRow() {
			const { selectedRow } = this.popupParams;
			return selectedRow;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001037'), //END 품번
					prop: 'partNo',
					width: '200px',
					headerAlign: 'center',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001193'), //END 품명
					prop: 'partNm',
					headerAlign: 'center',
					width: '370px',
					sortable: false
				},
				// {
				// 	label: '* ' + this.getMessage_('QWCC001096'), //op코드
				// 	prop: 'opCd',
				// 	width: '90px',
				// 	sortable: false,
				// 	custom: true
				// },
				// {
				// 	label: '* ' + this.getMessage_('QWCC001807'), //op코드명
				// 	prop: 'opNm',
				// 	width: '150px',
				// 	sortable: false
				// },
				{
					label: this.getMessage_('QWCC001040'), // 부품가격
					prop: 'partCst',
					width: '80px',
					sortable: false,
					custom: true
					/*
					form: {
						type: 'number',
						isDisabled: this.isDisabled, //추가된행은 편집을 못하게 한다.
						validation: { maxByteSize: 7 }
					}
					*/
				},
				{
					label: this.getMessage_('QWCC000977'), // 수량
					prop: 'qty',
					width: '90px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001101'), // 자재비
					prop: 'amt',
					width: '80px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001100'), //LTS
					prop: 'lts',
					width: '80px',
					sortable: false,
					custom: true
				},
				{
					label: this.getMessage_('QWCC001861'), // 기준금액
					prop: 'stdCst',
					width: '80px',
					sortable: false
					//custom: true
				},
				{
					label: this.getMessage_('QWCC001102'), // 공임비
					prop: 'wags',
					minWidth: '80px',
					sortable: false,
					custom: true
				}
			];
		},
		insVali() {
			return yup.object().shape({
				partNo: yup
					.string()
					.trim()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001037')]))
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001037')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChange(value, slotProps) {
			const key = slotProps.column.property;
			if (key === 'lts') {
				const arr = value.toString().split('.');
				value = value.replace(/[^.0-9]/g, '');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 2) {
						value = value.slice(0, 2) + '.';
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 1) {
						arr[1] = arr[1].slice(0, 1);
					}
					if (arr[0].length > 3) {
						arr[0] = arr[0].slice(0, 3);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
			} else if (key === 'qty') {
				value = value.replace(/[^0-9]/g, '');
				if (value.length > 3) {
					value = value.slice(0, 3);
				}
			} else if (key === 'partCst' || key === 'stdCst') {
				value = value.replace(/[^-\.0-9]/g, '');
				const arr = value.toString().split('.');
				if (arr.length > 2) {
					return;
				}
				if (arr.length == 1) {
					if (value.length > 8) {
						value = value.slice(0, 8);
					}
				}
				if (arr.length == 2) {
					if (arr[1].length > 2) {
						arr[1] = arr[1].slice(0, 2);
					}
					if (arr[0].length > 8) {
						arr[0] = arr[0].slice(0, 8);
					}
					arr[1] = '.' + arr[1];
					value = arr.reduce((a, b) => a + b);
				}
			}

			slotProps.row[key] = value;
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		closeModal() {
			this.DEFAULT_ASSIGN({
				key: 'popupParams',
				value: {
					show: false,
					selectedRow: {},
					opCd: '',
					lts: '',
					mtrlCst: ''
				}
			});
		},
		addAction() {
			//행추가
			let addRowData = {
				rowType: 'add',
				partNo: '',
				partNm: '',
				//opCd: '', //op코드
				lts: '', //lts
				qty: '', //수량
				partCst: '', //as 부품가격
				stdCst: this.popupParams.stdCst, //기준금액
				amt: '', //자재비
				wags: '' //공임비
			};

			this.rows.push(addRowData);

			this.$refs.CmpnPartTable.getTable().toggleRowSelection(addRowData);
		},
		getSelectedRows() {
			const defaultObj = this.insVali.cast();
			const rows = this.$refs.CmpnPartTable.getSelectedRows().map(row =>
				_(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value()
			);
			return rows;
		},
		saveAction() {
			//저장
			const selected = this.$refs.CmpnPartTable.getSelectedRows();
			const Rows = this.rows;

			//벨리데이션체크
			try {
				let sumAmt = 0;
				let sumLts = 0;
				for (let i = 0; i < Rows.length; i++) {
					this.insVali.validateSync(Rows[i]);

					!Rows[i].partCst ? (Rows[i].partCst = 0) : (Rows[i].partCst = Number(Rows[i].partCst));
					!Rows[i].qty ? (Rows[i].qty = 0) : (Rows[i].qty = Number(Rows[i].qty));
					!Rows[i].lts ? (Rows[i].lts = 0) : (Rows[i].lts = Number(Rows[i].lts));
					!Rows[i].stdCst ? (Rows[i].stdCst = 0) : (Rows[i].stdCst = Number(Rows[i].stdCst));
					//합계 체크
					Rows[i].amt = Rows[i].partCst * Rows[i].qty;

					sumLts = sumLts + Rows[i].lts;
					sumAmt = sumAmt + Rows[i].amt;
				}

				//교환부품수량 합계
				sumLts = sumLts.toFixed(1);
				sumAmt = sumAmt.toFixed(2);

				//op코드의 합계
				const opLts = this.popupParams.lts.toFixed(1);
				const mtrlCst = this.popupParams.mtrlCst.toFixed(2);

				if (opLts !== sumLts) {
					//해당 캠페인의 LTS값과 다릅니다
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001956') });
				} else if (mtrlCst !== sumAmt) {
					//해당 캠페인의 자재비의 값과 다릅니다
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001957') });
				} else {
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
						buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
					});
				}
				//컨펌창
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);

			try {
				//const saveRows = this.$refs.CmpnPartTable.getSelectedRows();
				const saveRows = this.rows;
				const cmpnNo = this.cmpnMstPopup.cmpnNo;
				const opCd = this.popupParams.opCd;

				const params = { cmpnNo: cmpnNo, opCd: opCd, saveRows: saveRows };

				const { code, messageCd } = await this.savePartList_(params);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				//Table();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.closeModal();
				this.$sf_toggleLoading(false);
			}
		},
		deleteAction() {
			//삭제
			const selected = this.$refs.CmpnPartTable.getSelectedRows();
			let rowN = 0;
			let rowTypeFlg = false;

			for (let i = 0; i < this.rows.length; i++) {
				this.rows[i].rowNum = rowN + 1;
				rowN = this.rows[i].rowNum;
			}

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000103'),
					message: this.getMessage_('QWCC000914')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			for (let i = 0; i < this.rows.length; i++) {
				for (let j = 0; j < selected.length; j++) {
					if (this.rows[i].rowNum == selected[j].rowNum) {
						if (selected[j].causYn == 'Y') {
							this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001965') });
							//rowTypeFlg == true;
							break;
						} else {
							this.rows.splice(i, 1);
							i--;
						}
					}
				}
			}

			// if (rowTypeFlg == true) {
			// 	try {
			// 		//컨펌창
			// 		this.$sf_showMessage({
			// 			type: 'confirm',
			// 			icon: 'confirm',
			// 			title: this.getMessage_('SWCC000108'), //삭제하시겠습니까?
			// 			buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: this.save }] //삭제된 로우 저장
			// 		});
			// 	} catch (error) {
			// 		this.$sf_toast({ type: 'error', message: error.message });
			// 	} finally {
			// 		this.$sf_toggleLoading(false);
			// 	}
			// }
		},
		async delete() {
			this.$sf_toggleLoading(true);

			try {
				const saveRows = this.$refs.CmpnPartTable.getSelectedRows();
				const cmpnNo = this.cmpnMstPopup.cmpnNo;
				const opCd = this.popupParams.opCd;
				const params = { cmpnNo: cmpnNo, opCd: opCd, saveRows: saveRows };

				const { code, messageCd } = await this.deletePartList_(params);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				//this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}
		},
		onCausePartPopup(param) {
			//원인부품명
			this.partNoInput = {
				partNo: param.row.partNo,
				opCd: this.popupParams.opCd
			};

			this.selGridRowIndex = param.index;

			this.$emit('OpenGridPartPopup', this.partNoInput);
		},
		onOpCdPopup(param) {
			const causPartNo = param.row.partNo;
			const commCd = {
				commCdType: 'OP_CD',
				commCd: param.row.opCd,
				causPartNo: causPartNo,
				title: this.getMessage_('QWCC001096')
			};

			this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.

			this.$emit('OpenGridOpPopup', commCd);
		},
		gridParNoPopUp(param) {
			let dataArr = this.cmpnPartList.slice();
			let check = false;
			//교환부품 END품번 중복 체크
			for (let i = 0; i < this.rows.length; i++) {
				if (this.rows[i].partNo == param.partNo) {
					check = true;
				}
			}
			if (check == false) {
				dataArr[this.selGridRowIndex].partNo = param.partNo;
				dataArr[this.selGridRowIndex].partNm = param.partNm;
			} else {
				this.$sf_toast({ type: 'error', message: this.getMessage_('SWCC000793') });
			}
		},
		gridOpCdPopUp(param) {
			let dataArr = this.cmpnPartList.slice();
			dataArr[this.selGridRowIndex].opCd = param.commCd;
			dataArr[this.selGridRowIndex].opNm = param.commCdName;
		}
	}
};
</script>
